(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-product-tabs"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const tabTitles = document.querySelectorAll('.tab-title');
    const tabContents = document.querySelectorAll('.tab-content');

    if (tabTitles.length && tabContents.length) {
      tabTitles.forEach((title) => {
        title.addEventListener('click', function (e) {
          e.preventDefault();
          if (title.classList.contains('is-active')) return;
          const targetId = title.getAttribute('href');
          const content = targetId ? document.querySelector('.tab-content' + targetId) : null;
          if (!content) return;
          tabTitles.forEach(t => t.classList.remove('is-active'));
          tabContents.forEach(c => c.classList.remove('is-active'));
          title.classList.add('is-active');
          setTimeout(() => {
            content.classList.add('is-animating');
            content.classList.add('is-active');
            content.addEventListener('transitionend', function handler() {
              content.classList.remove('is-animating');
              content.removeEventListener('transitionend', handler);
            });
          }, 10);
        });
      });
    }

    const toggleLinks = document.querySelectorAll('.toggle-link');

    toggleLinks.forEach(toggleLink => {
      toggleLink.addEventListener('click', function(e) {
        e.preventDefault();

        const toggleTitle = toggleLink.closest('.toggle-title');
        if (!toggleTitle) return;

        const tabTitleText = document.querySelector('.tab-title-text');
        if (tabTitleText) {
          tabTitleText.textContent = toggleLink.textContent;
        }

        const viewContentType = toggleTitle.dataset.viewContent;
        const content = toggleTitle.nextElementSibling;
        if (!content) return;

        switch (viewContentType) {
          case 'sidebar': {
            const drawerContent = document.querySelector('#Global-Drawer .drawer__wrapper');
            if (drawerContent) {
              drawerContent.innerHTML = '';
              drawerContent.appendChild(content.cloneNode(true));
              renderVideo();
            }
            break;
          }
          case 'popup': {
            const popupContent = document.querySelector('.popup-content-wrapper');
            if (popupContent) {
              popupContent.innerHTML = '';
              popupContent.appendChild(content.cloneNode(true));
              renderVideo();
            }
            break;
          }
          default:
            toggleTitle.classList.toggle('is-open');
        }
      });
    });
    const modalTemplate = `
      <side-drawer
        class="popup__content video-modal drawer fixed top-0 left-0 z-9 w-screen h-full flex justify-center no-js-hidden"
        element-s-popup=""
        id="PopupModal-AZDFEMWdKNDFCVHdoM__popup_link_desc_video"
        data-moved="true"
      >
        <div
          id="Drawer-Overlay-AZDFEMWdKNDFCVHdoM__popup_link_desc_video"
          class="drawer__overlay fixed inset-0 cursor-pointer"
          style="transform: translateX(0px)"
        ></div>
        <div
          class="popup__inner color-scheme-1 popup__inner--video w-auto h-full absolute-c-c flex flex-column global-settings-popup"
        >
          <div
            class="popup__inner--content relative w-full h-full overflow-auto cus-scrollbar"
          >
            <div class="video-modal__content-block">Video</div>
            <button
              onclick="this.closest('side-drawer').close()"
              class="button button-unstyled close-button popup__close minimum-touch-target-before drawer__close block t-button bor-none rounded-full cursor-pointer absolute"
              type="button"
              aria-label="Close dialog"
              style="--top: 0.3rem; --right: 0.3rem"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                class="icon icon-close"
                viewBox="0 0 18 17"
              >
                <path
                  fill="currentColor"
                  d="M.865 15.978a.5.5 0 0 0 .707.707l7.433-7.431 7.579 7.282a.501.501 0 0 0 .846-.37.5.5 0 0 0-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 1 0-.707-.708L8.991 7.853 1.413.573a.5.5 0 1 0-.693.72l7.563 7.268z"
                ></path>
              </svg>
            </button>
          </div>
        </div>
      </side-drawer>
    `;
    document.body.insertAdjacentHTML('beforeend', modalTemplate);

    function renderVideo() {
      const videoOpenPopups = document.querySelectorAll('.video-open-popup');
    
      if (videoOpenPopups.length > 0) {
        videoOpenPopups.forEach(videoOpenPopup => {
          videoOpenPopup.addEventListener('click', function(e) {
            e.preventDefault();

            const videoId = videoOpenPopup.dataset.videoId;
            const videoWrapper = document.querySelector('.video-modal__content-block');

            const youtubeIframe = `
            <iframe width="100%" src="https://www.youtube.com/embed/${videoId}?si=6yJ56P_BJEG5d2Uq" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            `;

            videoWrapper.innerHTML = youtubeIframe;
          });
        });
      }
    }
    renderVideo();
  });

  } catch(e) { console.error(e); }
})();
})();
